import type { Chord } from 'svguitar';

export const AChords: Record<string, Chord> = {
  A: {
    fingers: [
      [1, 0],
      [2, 2, '3'],
      [3, 2, '2'],
      [4, 2, '1'],
      [5, 0, { color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'A',
    position: 0,
  },
  A9: {
    fingers: [
      [1, 0],
      [2, 0],
      [3, 2, '2'],
      [4, 2, '1'],
      [5, 0, { color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'A9',
    position: 0,
  },
  'A9/C#': {
    fingers: [
      [1, 0],
      [2, 0],
      [3, 2, '2'],
      [4, 2, '1'],
      [5, 4, { text: '4', color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'A9/C#',
    position: 0,
  },
  Am: {
    fingers: [
      [1, 0],
      [2, 1, '1'],
      [3, 2, '3'],
      [4, 2, '2'],
      [5, 0, { color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'Am',
    position: 0,
  },
  Am7: {
    fingers: [
      [1, 0],
      [2, 1, '1'],
      [3, 0],
      [4, 2, '2'],
      [5, 0, { color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'Am7',
    position: 0,
  },
};
